import * as React from "react";
import {useCartContext} from "./CartContextProvider/CartContextProvider";
import {useTranslation} from "react-i18next";
import genericStyles from "../lib/GenericStyles.module.scss";

const RedBorderBox: React.FC = () => {
  const {cart, cartErrors,externalErrors} = useCartContext();
  const {t} = useTranslation();

  if (!cartErrors.length && !externalErrors.length) {
    return null;
  }

  return (
    <div className={genericStyles.errorBlockMain}>
      <ul>
        {[...cartErrors, ...externalErrors].map((entry, index) => {
          if (!entry.itemId) {
            return <li key={index}>{entry.message}</li>;
          }

          const deleteHandler = (evt: React.MouseEvent<HTMLAnchorElement>) => {
            evt.preventDefault();
            void cart.removeItem(entry.itemId ?? 0);
          };

          if (entry.itemExists) {
            const jumpToHandler = (evt: React.MouseEvent<HTMLAnchorElement>) => {
              evt.preventDefault();
              handleGotoErrorLinkClick(`#error_item_${entry.itemId ?? 0}`);
            };

            return (
              <li key={index}>
                {entry.message}{" "}
                <React.Fragment>
                  <span className={genericStyles.jumpToError} onClick={jumpToHandler}>
                    {t("general.goToError")}
                  </span>
                  <span
                    className={`${genericStyles.jumpToError} ${genericStyles.deleteOnDesktop}`}
                    onClick={deleteHandler}
                  >
                    {t("general.delete")}
                  </span>
                </React.Fragment>
              </li>
            );
          }

          return (
            <li key={index}>
              {entry.message}{" "}
              <a href="#" onClick={deleteHandler}>
                {t("general.delete")}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default RedBorderBox;

const handleGotoErrorLinkClick = (selectorQuery: string): void => {
  const refObject = document.body.querySelector(selectorQuery);
  if (!refObject) {
    return;
  }
  const section = document.querySelector("#ModalRootElement > section");
  if (!section) {
    return;
  }
  const topOffset = refObject.getBoundingClientRect().top + section.scrollTop;

  if ("scrollIntoView" in refObject) {
    refObject.scrollIntoView({behavior: "smooth", inline: "start"});
  } else if (typeof section.scrollTo === "function") {
    section.scrollTo({left: 0, top: topOffset, behavior: "smooth"});
  } else {
    section.scrollTop = topOffset;
    section.scrollLeft = 0;
  }
};
